import React, { ErrorInfo, ReactNode } from 'react';

type Props = {
  children?: ReactNode;
  backupComponent?: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(error: any): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {}

  render() {
    /**UI en caso de falla general. */
    if (this.state.hasError) {
      return this.props.backupComponent ?? <></>;
    }
    /**UI en caso normal (sin falla). */
    return this.props.children;
  }
}
